export const EMAIL_PATTERN  = /^([A-Z0-9._%+-]+)(\+[.A-Z0-9-]+)?@([A-Z0-9-.]{2,})(\.[A-Z0-9-]{2,8})$/i;
export const NUMBER_PATTERN = /^[0-9]{1,}$/;
